function resizeNav() {
    var newHeight = window.innerHeight;
    $('.header-mobile-content').css('max-height', newHeight );
}

$(document).ready(function() {
    resizeNav();
 
    $(window).on('resize', function () {
        resizeNav();
    });
    
    //home change header color on scroll
    $(window).scroll(function() {
        var scroll = $(window).scrollTop();
        if (scroll >= 100) {
            $(".site-header").addClass('active');
        } else {
            $(".site-header").removeClass('active');
        }
    })


    //dropdown function
    $('.menu-top .menu-item-has-children').each(function() {
        $(this).children('a').addClass('dropdown-link');
    });
    $('.dropdown-link').each(function() {
        $(this).click(function(e) {
            e.preventDefault();

            $(".dropdown-link").next().not($(this).next()).removeClass('dropdown');
            $(".dropdown-link").next().not($(this).next()).slideUp();
            if ($(this).next().hasClass('dropdown')) {
                $(this).next().removeClass('dropdown');
                $(this).next().slideUp();
            } else {
                $(this).next().addClass('dropdown');
                $(this).next().slideDown();
            }
        });
    })
    // //close dropdown if click on page
    $(document).mouseup(function(e) {
        var container = $(".sub-menu, .dropdown-link");
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            $(".dropdown-link").next().removeClass('dropdown');
            $(".dropdown-link").next().slideUp();
        }
    });


    $('.mobile--inner--wrapper .menu-item-has-children').each(function() {
        $(this).addClass('acc-submenu');
    });
    $('.mobile--inner--wrapper .menu-item-has-children').each(function() {
        $(this).children('a').click(function(e) {
            e.preventDefault();
            $(this).toggleClass('rotate');
            $(this).next().toggleClass('acc--menu--open');
            $(this).next().slideToggle('slow');
        });
    });




    $('.burger--menu--toggle').click(function() {
        $('.burger--menu--toggle').prop('disabled', true);

        //mobile menu animation
        if (!$('.header-mobile-content').hasClass("header--open")) {
            //burger toggle animation
            $('.burger--menu--toggle').addClass("burger--closed");
            $('body').addClass('nav--open');


            //open menu
            $('.header-mobile-content').addClass("header--open").removeClass("header--closed");
            $('html, body').css({
                overflow: 'hidden',
            });
        } else {
            //burger toggle animation
            $('.burger--menu--toggle').removeClass("burger--closed");
            $('body').removeClass('nav--open');

            //close menu
            $('.header-mobile-content').removeClass("header--open").addClass("header--closed");
            $('html, body').css({
                overflow: 'visible',
            });

            // close submenus
            // $('#menu-main .dropdown-menu').removeClass('menu--slide--in');
            // $('#menu-main .dropdown-menu').slideUp('slow');
        }

        setTimeout(function() {
            // enable click after 1 second
            $('.burger--menu--toggle').prop('disabled', false);
        }, 500); // .5 second delay

    });



    // //close menu if click on page
    $(document).mouseup(function(e) {
        var container = $(".header--open, .header--burger");

        // if the target of the click isn't the container nor a descendant of the container
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            $('.header-mobile-content').removeClass("header--open");
            $('.burger--menu--toggle').removeClass('burger--closed');
            $('html, body').css({
                overflow: 'visible',
            });
            $('body').removeClass('nav--open');

            // close submenus
            // $('#menu-main .dropdown-menu').removeClass('menu--slide--in');
            // $('#menu-main .dropdown-menu').slideUp('slow');
        }
    });

    // Close mobile menu when any link is clicked (except dropdown toggles)
    $('.header-mobile-content a').click(function(e) {
        // Don't close menu if this is a dropdown toggle link
        if (!$(this).parent().hasClass('menu-item-has-children')) {
            // Close the mobile menu
            $('.header-mobile-content').removeClass("header--open").addClass("header--closed");
            $('.burger--menu--toggle').removeClass('burger--closed');
            $('html, body').css({
                overflow: 'visible',
            });
            $('body').removeClass('nav--open');
        }
    });

    // Handle hash links - redirect to homepage if not already there
    $('.header-mobile-content a, .menu-top a').click(function(e) {
        var href = $(this).attr('href');
        
        // Check if this is a hash link (starts with #)
        if (href && href.startsWith('#')) {
            // Check if we're not on the homepage
            if (window.location.pathname !== '/' && window.location.pathname !== '/index.php') {
                e.preventDefault();
                // Redirect to homepage with the hash
                window.location.href = '/' + href;
            }
        }
    });

    //hide navbar on scroll
    $(function() {
        var lastScrollTop = 0,
            delta = 5;
        $(window).scroll(function() {
            var nowScrollTop = $(this).scrollTop();
            var scroll = $(window).scrollTop();

            if (Math.abs(lastScrollTop - nowScrollTop) >= delta) {
                if (nowScrollTop > lastScrollTop) {
                    // SCROLLING DOWN
                    if (scroll >= 600) {
                        $('.site-header').removeClass('nav-down').addClass('nav-up');
                    }
                } else {
                    // SCROLLING UP
                    $('.site-header').removeClass('nav-up').addClass('nav-down');
                }
                lastScrollTop = nowScrollTop;
            }
        });
    });
});
